import axios from 'axios';
import moment from 'moment';
import { mapState } from 'vuex';
import { db } from '@/db';
import { cloudFunctions, stripePublicKey } from '../config';

export default {
  name: 'stripe-mixin',

  data() {
    return {
      stripe: undefined,
      buttonLabel: 'Swipe-Package jetzt kaufen',
      stripeValidationError: '',
      loading: false,
    };
  },

  computed: {
    ...mapState(['userType', 'user_data']),
  },

  methods: {
    async createPaymentIntent(orderedItem) {
      const paymentIntent = await axios({
        method: 'post',
        url: `${cloudFunctions}/stripeCreatePaymentIntent`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: { orderedItem },
      });
      return paymentIntent.data.clientSecret;
    },

    async createPaymentIntentWallet(orderedItem) {
      const paymentIntent = await axios({
        method: 'post',
        url: `${cloudFunctions}/stripeCreatePaymentIntentWallet`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: { orderedItem },
      });
      return paymentIntent.data.clientSecret;
    },

    async createSetupIntent(customerId) {
      const paymentIntent = await axios({
        method: 'post',
        url: `${cloudFunctions}/stripeCreateSetupIntent`,
        headers: {
          'content-type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
        data: { customerId },
      });
      return paymentIntent.data.clientSecret;
    },

    updateButtonLabel(orderedItem, paymentMethod, bankName) {
      // dont update button text

      // const amount = orderedItem.price;
      // let label = `Bezahle ${amount}`;
      // if (paymentMethod !== 'card') {
      //   label = `Bezahle ${amount} mit ${paymentMethod}`;
      // }
      // if (paymentMethod === 'wechat') {
      //   label = `Generate QR code to pay ${amount} with ${name}`;
      // }
      // if (['sepa_debit', 'au_becs_debit'].includes(paymentMethod) && bankName) {
      //   label = `Debit ${amount} from ${bankName}`;
      // }
      // this.buttonLabel = label;
      this.buttonLabel =
        this.userType === 'teams'
          ? 'Saisonticket jetzt kaufen'
          : 'Swipe-Package jetzt kaufen';
    },

    // subscriptions
    async processPaymentSubscribe() {
      console.log('subscribe');
      this.$store.state.loading = true;
      this.payButtonDisabled = true;
      this.$refs.submitButton.textContent = 'Processing…';

      // If a previous payment was attempted, get the lastest invoice
      // const latestInvoicePaymentIntentStatus = localStorage.getItem(
      //   'latestInvoicePaymentIntentStatus',
      // );

      // todo: enable 2nd retry if payment declined
      // todo: show info about last subscription and posibility to start new one

      // if (latestInvoicePaymentIntentStatus === 'requires_payment_method') {
      //   const invoiceId = localStorage.getItem('latestInvoiceId');
      //   const isPaymentRetry = true;
      //   // create new payment method & retry payment on invoice with new payment method
      //   this.createPaymentMethod({
      //     isPaymentRetry,
      //     invoiceId,
      //   });
      // } else {
      // create new payment method & create subscription
      this.createPaymentMethod({});
      // }
    },

    async attachPaymentToCustomer({ paymentMethodId }) {
      const data = {
        customerId: this.stripeCustomerId,
        paymentMethodId,
      };

      return (
        axios({
          method: 'post',
          url: `${cloudFunctions}/stripeAttachPaymentToCustomer`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data,
        })
          .then((response) => response.data)
          // If the iban is declined, display an error to the user.
          .then((result) => {
            if (result.error) {
              // The iban had an error when trying to attach it to a customer
              throw result;
            }
            return result;
          })
          .catch((error) => {
            console.log(error);
            this.stripeValidationError = error.message || error;
            this.$refs.paymentErrors.classList.remove('hide');
            this.$store.state.loading = false;
          })
      );
    },

    getExpiryDate() {
      const { subscriptionStart, subscriptionTimeInMonths } = this.user_data.subscriptionData;
      const today = moment();
      const startDayAndHour = moment.unix(subscriptionStart).format('DD HH:mm');
      const diff = Math.abs(moment.unix(subscriptionStart).diff(today, 'months'));
      const restMonths = subscriptionTimeInMonths - diff % subscriptionTimeInMonths;
      const endYearAndMonth = moment().add(restMonths, 'months').format('YYYY-MM');
      const endDay = `${endYearAndMonth}-${startDayAndHour}`;
      const subscriptionExpiryDate = moment(endDay, 'YYYY-MM-DD HH:mm').unix();

      return subscriptionExpiryDate;
    },

    cancelSubscriptionStripe({ subscriptionId }) {
      const data = {
        subscriptionId,
      };

      return (
        axios({
          method: 'post',
          url: `${cloudFunctions}/stripeCancelSubscription`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data,
        })
          .then((response) => response.data)
          // If the card is declined, display an error to the user.
          .then((result) => {
            if (result.error) {
              // The card had an error when trying to attach it to a customer
              throw result;
            }
            return result;
          })
          .then((result) => {
            const subscriptionExpiryDate = this.getExpiryDate();

            this.user_data.subscriptionData.isCanceled = true;
            this.user_data.subscriptionData.subscriptionExpiryDate = subscriptionExpiryDate;
            
            this.loading = false;
            this.subscription_dialog = false;
            this.$store.state.loading = false;

            this.$store.commit({
              type: 'openSnackbar',
              text: 'Dein Abo wurde gekündigt.',
            });
            db.collection(this.userType)
              .doc(this.user_data.id)
              .update({ ...this.user_data });
          })
          .catch((error) => {
            console.log(error);
            this.$store.state.loading = false;
          })
      );
    },

    createSubscription({ paymentMethodId, promoCode }) {
      const data = {
        customerId: this.stripeCustomerId,
        paymentMethodId,
        priceId: this.orderedItem.id,
        accountId: this.user_data.id,
        accountType: this.userType,
      };

      if (promoCode) {
        data.promoCode = promoCode.id;
      }

      return (
        axios({
          method: 'post',
          url: `${cloudFunctions}/stripeCreateSubscription`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data,
        })
          .then((response) => response.data)
          // If the card is declined, display an error to the user.
          .then((result) => {
            if (result.error) {
              // The card had an error when trying to attach it to a customer
              throw result;
            }
            return result;
          })
          // Normalize the result to contain the object returned
          // by Stripe. Add the addional details we need.
          .then((result) => ({
            // Use the Stripe 'object' property on the
            // returned result to understand what object is returned.
            subscription: result,
            paymentMethodId,
            priceId: this.orderedItem.id,
          }))
          // Some payment methods require a customer to do additional
          // authentication with their financial institution.
          // Eg: 2FA for cards.
          .then(this.handlePaymentThatRequiresCustomerAction)
          // If attaching this card to a Customer object succeeds,
          // but attempts to charge the customer fail. You will
          // get a requires_payment_method error.
          .then(this.handleRequiresPaymentMethod)
          // No more actions required. Provision your service for the user.
          .then(this.onSubscriptionComplete)
          .catch((error) => {
            console.log(error);
            this.stripeValidationError = error.error ? error.error.message : error;
            this.$refs.paymentErrors.classList.remove('hide');
            this.$store.state.loading = false;
          })
      );
    },

    handleRequiresPaymentMethod({ subscription, paymentMethodId, priceId }) {
      console.log(
        'handleRequiresPaymentMethod',
        subscription,
        paymentMethodId,
        priceId,
      );

      if (subscription.status === 'active') {
        // subscription is active, no customer actions required.
        return { subscription, priceId, paymentMethodId };
      }

      if (
        subscription.latest_invoice.payment_intent.status === 'requires_payment_method'
      ) {
        // Using localStorage to store the state of the retry here
        // (feel free to replace with what you prefer)
        // Store the latest invoice ID and status
        localStorage.setItem('latestSubscription', JSON.stringify(subscription));
        localStorage.setItem('latestInvoiceId', subscription.latest_invoice.id);
        localStorage.setItem(
          'latestInvoicePaymentIntentStatus',
          subscription.latest_invoice.payment_intent.status,
        );
        // this.stripeValidationError = error.message;
        // this.$refs.paymentErrors.classList.remove('hide');
        throw new Error('Your payment was declined.');
      } else {
        return { subscription, priceId, paymentMethodId };
      }
    },

    retryInvoiceWithNewPaymentMethod({ paymentMethodId, invoiceId }) {
      console.log('retryInvoiceWithNewPaymentMethod', paymentMethodId, invoiceId);

      const data = {
        customerId: this.stripeCustomerId,
        paymentMethodId,
        invoiceId,
      };

      return (
        axios({
          method: 'post',
          url: `${cloudFunctions}/stripeRetryInvoice`,
          headers: {
            'content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
          data,
        })
          .then((response) => response.data)
          // If the card is declined, display an error to the user.
          .then((result) => {
            if (result.error) {
              // The card had an error when trying to attach it to a customer
              throw result;
            }
            return result;
          })
          // Normalize the result to contain the object returned
          // by Stripe. Add the addional details we need.
          .then((result) => ({
            // Use the Stripe 'object' property on the
            // returned result to understand what object is returned.
            invoice: result,
            paymentMethodId,
            priceId: this.orderedItem.id,
            isRetry: true,
          }))
          // Some payment methods require a customer to be on session
          // to complete the payment process. Check the status of the
          // payment intent to handle these actions.
          .then(this.handlePaymentThatRequiresCustomerAction)
          // No more actions required. Provision your service for the user.
          .then(this.onSubscriptionComplete)
          .catch((error) => {
            console.log(error);
            this.stripeValidationError = error.error ? error.error.message : error;
            this.$refs.paymentErrors.classList.remove('hide');
            this.$store.state.loading = false;
          })
      );
    },

    onSubscriptionComplete(result) {
      console.log(result);
      if (
        (result.subscription && result.subscription.status === 'active') ||
        result.repeatedPaymentStatus === 'succeeded'
      ) {
        let results = { ...result };
        const batch = db.batch();
        const subscriptionId =
          result.repeatedPaymentStatus === 'succeeded'
            ? result.invoice.subscription
            : result.subscription.id;
        const subscriptionData = {
          subscriptionId,
          isCanceled: false,
          subscriptionTimeInMonths: results.subscription.plan.interval_count,
          subscriptionStart: moment().unix(),
        };

        if (this.latestSubscription) {
          results = {
            ...results,
            subscription: this.latestSubscription,
          };
        }

        const userRef = db.collection(this.userType).doc(this.user_data.id);
        batch.update(userRef, { subscriptionData });

        const subscriptionRef = db.collection('subscriptions').doc(subscriptionId);
        batch.set(subscriptionRef, results);

        // run batch
        batch
          .commit()
          .then(() => {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Dein Abo wurde aktiviert.',
            });
            this.$store.state.loading = false;
            this.clearCache();
            this.$store.dispatch('setSubscriptionData');
          })
          .catch((err) => {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Ups, da ist etwas schief gelaufen.',
            });
            this.$store.state.loading = false;
            console.log({ err });
          });
      } else {
        this.$store.commit({
          type: 'openSnackbar',
          text: 'Ups, da ist etwas schief gelaufen.',
        });
        this.$store.state.loading = false;
      }
    },

    clearCache() {
      localStorage.clear();
    },
  },

  mounted() {
    this.stripe = Stripe(stripePublicKey);
  },
};
